module.exports = __webpack_public_path__ + "assets/img/19_861_big.b14d62d6.jpg";